/* DSL custom IntersectionObserver lazy-loader voor [data-src] / [data-srcset] / iframe[data-src] */
(function(){
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll("[data-src]").forEach(function(el){
      el.src = el.dataset.src;
      if (el.dataset.srcset) el.srcset = el.dataset.srcset;
    });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      var el = entry.target;
      if (el.dataset.src) el.src = el.dataset.src;
      if (el.dataset.srcset) el.srcset = el.dataset.srcset;
      if (el.dataset.poster) el.poster = el.dataset.poster;
      el.removeAttribute("data-src");
      el.removeAttribute("data-srcset");
      el.classList.add("dsl-lazy-loaded");
      io.unobserve(el);
    });
  }, {rootMargin: "200px 0px", threshold: 0.01});
  function bind(){
    document.querySelectorAll("[data-src]:not(.dsl-lazy-loaded), [data-srcset]:not(.dsl-lazy-loaded)").forEach(function(el){
      io.observe(el);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else { bind(); }
  // Re-scan after DOM mutations (swatch swap, lazy-rendered sections)
  if ("MutationObserver" in window) {
    new MutationObserver(bind).observe(document.body, {childList: true, subtree: true});
  }
})();